const getVwoUUIDFromCookie = (accountId) => {
  const uuidCookie = getCookie('myfonts_custom_uuid');
  if(uuidCookie){
    return uuidCookie;
  }
  const uuid = vwoSdk.getUUID(getAnonymousID(), accountId);
  setCookie('myfonts_custom_uuid', uuid, 30); // 30 days
  localStorage.setItem('myfonts_custom_uuid', uuid);
  return uuid;
}

async function vwoFeatureFlagEnabler(accountId, sdkKey){
    try{
        const queryParams = new URLSearchParams(window.location.search);
        const experimentalAiSearch = queryParams.get('experimental_ai_search');
        const options = {
          accountId: accountId,
          sdkKey: sdkKey 
        };
        const vwoClient = await vwoSdk.init(options);
        const userContext = {
          id: getVwoUUIDFromCookie(accountId)
        }
        const flag = await vwoClient.getFlag("aiSearch", userContext);
        const isFeatureFlagEnabled = flag.isEnabled();
        const el = document.getElementsByClassName("ai_search_dotlottie_wrapper")[0];
        console.log("is feature flag enabled", isFeatureFlagEnabled, userContext)
        if(isFeatureFlagEnabled || experimentalAiSearch === 'x_ai_true'){
          gs_settings.config.contextualSearch.isEnabled = true;
          loadSearchBar();
          if(window.location.pathname.includes("ai-search")){
            const slideWrapper = document.getElementsByClassName("gh-sliderWrapper")[0];
            if (slideWrapper && slideWrapper.style) {
              slideWrapper.style.display = 'none';
            }
          }
        }else {
          if(window.location.pathname.includes("ai-search")){
            const searchPageUrl = myfonts.locale === 'en' ? '/search' : `/${myfonts.locale}/search`;
            window.location.href = searchPageUrl;
          }
          if(el){
            el.remove();
          }else{
            if(typeof searchPageData !== 'undefined'){
              searchPageData.config.contextualSearch.isEnabled = false;
            }
            
          }
        }
      } catch (e) {
        console.error(e);
      }
}
